import ApplePay from './ApplePay';
import GooglePay from './GooglePay';
import CreditCard from './CreditCard';
import PayPal from './PayPal';
import StoredPaymentMethods from './StoredPaymentMethods';

export {ApplePay, CreditCard, GooglePay, PayPal, StoredPaymentMethods};
